module.exports = __webpack_public_path__ + "static/lesson_6-805b674fb634143b1205779ea1c3653c.png";